// Email subscription service
export const emailService = {
  // Subscribe email to Sanity backend
  subscribe: async (email) => {
    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Subscription failed');
      }
      
      return await response.json();
    } catch (error) {
      // Fallback to localStorage if API fails
      if (!email || !email.includes('@')) {
        throw new Error('Please enter a valid email address');
      }

      const existingEmails = JSON.parse(localStorage.getItem('subscribedEmails') || '[]');
      
      if (existingEmails.some(sub => sub.email === email)) {
        throw new Error('Email already subscribed');
      }

      const newSubscription = {
        email,
        date: new Date().toISOString(),
        id: Date.now().toString(),
        status: 'active'
      };
      
      existingEmails.push(newSubscription);
      localStorage.setItem('subscribedEmails', JSON.stringify(existingEmails));
      
      return newSubscription;
    }
  },

  getSubscribers: () => {
    return JSON.parse(localStorage.getItem('subscribedEmails') || '[]');
  },

  getSubscriberCount: () => {
    return emailService.getSubscribers().length;
  },

  notifySubscribers: (newPost) => {
    const subscribers = emailService.getSubscribers();
    const notifications = emailService.getNotificationHistory();
    
    const notification = {
      id: Date.now().toString(),
      postTitle: newPost.title,
      postSlug: newPost.slug?.current || 'test-post',
      sentTo: subscribers.length,
      sentAt: new Date().toISOString(),
      subscribers: subscribers
    };
    
    notifications.push(notification);
    localStorage.setItem('emailNotifications', JSON.stringify(notifications));
    localStorage.setItem('lastNotification', JSON.stringify(notification));
    
    console.log('📧 Test notification sent to', subscribers.length, 'subscribers');
    return { sent: true, count: subscribers.length };
  },

  clearAll: () => {
    localStorage.removeItem('subscribedEmails');
    localStorage.removeItem('emailNotifications');
    localStorage.removeItem('lastNotification');
  },

  getNotificationHistory: () => {
    return JSON.parse(localStorage.getItem('emailNotifications') || '[]');
  },

  getLastNotification: () => {
    return JSON.parse(localStorage.getItem('lastNotification') || 'null');
  }
};